import { PlatformsAuthEvent, PlatformsAuthSignupSuccessEvent } from '~/types';

export function isPlatformsAuthSignupSuccessEvent(
  evnt: PlatformsAuthEvent
): evnt is PlatformsAuthSignupSuccessEvent {
  return (
    evnt.type === 'authservice-sso-foam-signup-success' ||
    evnt.type === 'authservice-sso-echo-signup-success'
  );
}
